export enum OptimizelyExperiments {
  isSupportAssistantEnabled = 'opex_support_assistant_customer_pool',
  emailChangeEnabled = 'opex_email_change',
  securePhoneNumberChangeEnabled = 'csx_secure_phone_number_change',
  croLPFreePreviewAfterSignUpLogIn = 'cro_offer_lp_free_preview_after_sign_up_log_in',
  croAlwaysOnNewMobileBooking = 'cro_lpc_new_mobile_booking',
  croFlexibleFlightFares = 'cro_flexible_flight_fares',
  paymentsDepositOptionForHotelsAbove1999V2 = 'payments_deposit_option_for_hotels_above_1999_v2',
  carHireBundledDiscountUpcomingOrderHomepageCarousel = 'car_hire_bundled_discount_upcoming_order_homepage_carousel',
  croPopularOptionBookingRemaining = 'cro_popular_option_booking_remaining',
  growthShowOfferUrgencyCountdownLabel = 'growth_force_show_offer_urgency_countdown_label',
  croBundledFlexibleFlightFaresV2 = 'cro_bundled_flexible_flight_fares_v2',
  croHideHomepageSearchEmergingMarkets = 'cro_hide_homepage_search_emerging_markets',
  croWePriceMatchOfferPageTag = 'cro_we_price_match_tag',
  lereDynamicPricingUrgencyTag = 'lere_dynamic_pricing_urgency_tag',
  lereNonAUTwoTowersHomePageHeroCarouselV2 = 'lere_non_au_two_towers_home_page_hero_carousel_v2',
  lerePersonalisedHomePageHeroCarousel = 'lere_personalised_home_page_hero_carousel',
  experiencesSearchCompactTiles = 'experiences_search_compact_tiles',
  experiencesSearchCompactTilesTitles = 'experiences_search_compact_tiles_titles',
  croPrefetchInflowCheckoutExperiences = 'cro_prefetch_inflow_checkout_experiences',
  croPrefetchFlightsFromOffer = 'cro_prefetch_flights_from_offer',
  croOfferCtaSeeDeal = 'cro_offer_cta_see_deal',
  carHireObjectiveIntentMessage = 'car_hire_objective_intent_message',
  croFlexCfmrBedbankPackages = 'cro_flex_cfmr_bedbank_packages',
  growthMetasearchPerNightPricing = 'growth_metasearch_per_night_pricing',
  croOrderDownloadPdf = 'cro_order_download_pdf',
  checkoutPaymentSection = 'checkout_payment_section_v2',
  searchSortByGeographicDiversity = 'search_sort_by_geographic_diversity',
  cruiseAutoFocusNextFilter = 'cruise_auto_focus_next_filter',
  cruiseCheckoutHotelRecommendations = 'cruise_checkout_hotel_recommendations',
  labnableVideoBackground = 'lab_enable_video_background',
  searchNaturalLanguageSearch = 'search-natural-language-search-ab-test',
  searchNlsDescriptions = 'search_nls_descriptions',
  cruiseSearchTileRedesign = 'cruise_search_tile_redesign',
  loyaltyCommSubBonus = 'loyalty_communication_resubscription_bonus',
  croSearchTileReviewSize = 'cro_search_tile_review_size',
  croOffersEndingSoonCarousel = 'cro_offers_ending_soon_carousel',
  croOfferImageGallery = 'cro_offer_image_gallery',
  croFlightSearchCompactTiles = 'cro_flight_search_compact_tiles',
  paymentFlashPaymentSchedules = 'payment_flash_payment_schedules',
  croHotelSearchDirectlyFromVerticalPageMobileWeb = 'cro_hotel_search_directly_from_vertical_page_mobile_web',
  croNewReviewsPanel = 'cro_new_reviews_panel',
  croRemoveFlashHighlightsContentSection = 'cro_remove_flash_highlights_content_section',
  croInclusionsButNoMarketingTaglineFlashTiles = 'cro_inclusions_but_no_marketing_tagline_flash_tiles',
  croOpexCheckoutSecondaryTravellerEmail = 'cro_opex_checkout_optionally_collect_email_from_secondary',
  searchMultiBedroomsEnabled = 'search_multi_bedrooms_enabled',
  croPhoneNumberVerificationOnSignUp = 'cro_phone_number_verification_on_sign_up',
  croVillasVerticalPage = 'cro_villas_vertical_page',
  growthPaidOfferGalleryVariant = 'growth_paid_offer_gallery_variant',
  croLoyaltyAddPhonePointsReward = 'cro_loyalty_add_phone_points_reward',
  croMergeCabinOnFlightSaleTimes = 'cro_merge_cabin_on_flight_sale_times',
  lereRankerClustering = 'lere_ranker_clustering',
  experiencesCollections = 'experiences_collections',
}

export enum OptimizelyFeatureFlags {
  luxLoyaltyFeatureToggle = 'lux_loyalty_feature_toggle',
  luxPlusFeatureToggle = 'luxplus_feature_toggle',
  luxPlusToursToggle = 'luxplus_tours_toggle',
  luxPlusDiscountedInsuranceBenefit = 'lux_plus_discounted_insurance_benefit',
  luxPlusDiscountedBookingProtectionBenefit = 'lux_plus_discounted_booking_protection_benefit',
  luxPlusLppPricingEnabled = 'luxplus_lpp_pricing_enabled',
  luxPlusCruiseInclusionsEnabled = 'lux_plus_cruise_inclusions',
  luxPlusDiscountedExperiencesBenefit = 'lux_plus_discounted_experiences_benefit',
  allowPhoneNumberLogin = 'allow_phone_number_login',
  promoAppBanner = 'app_banner_targeted_delivery',
  CSAgentsAutoQuote = 'cro_cs_agents_auto_quote',
  toursRequestAgentCallbackEnabled = 'csx_tours_request_agent_callback',
  hotelsAndVillasRequestAgentCallbackEnabled = 'csx_hotels_and_villas_request_agent_callback',
  upsellTilesFeatureToggle = 'cro_upsell_on_homepage_and_my_escapes',
  croTravelPreferencesModalEnabled = 'cro_travel_preferences_modal',
  opexTermsAndConditionsModal = 'terms_and_conditions_modal',
  croWebPushNotificationPrompt = 'cro_web_push_notification_prompt',
  opexFraudOrdersOtp = 'opex_fraud_orders_otp',
  payIdTargetedRelease = 'pay_id_targeted_release',
  isGeneratedTripsEnabled = 'is_generated_trips_enabled',
  carHireBundledDiscount = 'car_hire_bundled_discount',
  lereDestinationModelEnabled = 'lere_personalised_destinations',
  lereOfferPageRecommendationsEnabled = 'lere_offer_page',
  lereHeroCarouselEnabled = 'lere_hero_carousel',
  opexHotelAddExtraGuestsEnabled = 'hotel_add_extra_guests',
  opexLPCAddExtraGuestsEnabled = 'lpc_add_extra_guests',
  flightsEnableSabreContent = 'flights_enable_sabre_content',
  loyaltyLuxPlusRenewalReward = 'loyalty_lux_plus_renewal_reward',
  loyaltyPointsDeductionWarning = 'loyal_points_deduction_warning',
  croInsuranceXCoverEnabled = 'cro_insurance_xcover_enabled',
  croPayAtProperty = 'cro_pay_at_property',
  croPackageUpgradeLibEnabled = 'cro_package_upgrade_lib_enabled',
  enableLabFeatureFlags = 'enable_lab_feature_flags',
  standaloneFlightLoungePassExperiencesEnabled = 'standalone_flight_lounge_pass_experiences_enabled',
  merchandiseLaunch = 'merchandise_launch',
  opexBookingAuthority = 'opex_booking_authority',
  opexLESAConditionalBubble = 'opex_lesa_conditional_bubble',
  opexBookingAuthorityManageAccess = 'opex_booking_authority_manage_access',
  trpTripChatPage = 'trp_trip_chat_page',
  luxRow = 'lux_row',
  searchMpvSalesRankingV3 = 'search_mpv_sales_ranking_3',
  searchRealTimeDateAndOccupancyExtraction = 'search_real_time_date_and_occupancy_extraction',
  croWrappedModalTravelled = 'cro_wrapped_modal',
  croWrappedModalAll = 'cro_wrapped_modal_all',
  croDisplaySimilarAccounts = 'cro_display_similar_accounts',
  randomizeExperiencesOffers = 'randomize_experiences_offers',
}
